import {UserNotificationStatus} from "../../constant/user/UserNotificationStatus"
import {UserNotificationSubject} from "../../constant/user/UserNotificationSubject"
import {UserNotificationModificationDomain} from "../../domain/user/UserNotificationModificationDomain"

export const UserNotificationModificationDescriptor: Record<keyof UserNotificationModificationDomain, (o: UserNotificationModificationDomain) => string> = {
    id(o: UserNotificationModificationDomain): string {
        return o.id.toString()
    },
    creatorId(o: UserNotificationModificationDomain): string {
        return o.creatorId.toString()
    },
    userNotificationId(o: UserNotificationModificationDomain): string {
        return o.userNotificationId.toString()
    },
    title(o: UserNotificationModificationDomain): string {
        return o.title
    },
    body(o: UserNotificationModificationDomain): string {
        return o.body
    },
    subject(o: UserNotificationModificationDomain): string {
        return UserNotificationSubject.description(o.subject)
    },
    deepLink(o: UserNotificationModificationDomain): string {
        return o.deepLink ?? '-'
    },
    statusFlags(o: UserNotificationModificationDomain): string {
        let enabled: string[] = []
        for (let key in UserNotificationStatus) {
            const flag = (UserNotificationStatus as any)[key] as { value: number, name: string } | any[]
            if (!Array.isArray(flag) && (o.statusFlags & flag.value) !== 0) {
                enabled.push(flag.name)
            }
        }

        return enabled.join('\n, ')
    },
    createdAt(o: UserNotificationModificationDomain): string {
        return o.createdAt.toISOString().substring(0, 19).replace('T', ' ')
    }
}
